var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 236,
    viewBox: "0 0 169 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160.6 139.6L0.5 232V95.6003C0.5 93.3003 1.9 90.7003 3.6 89.7003L157.5 0.900259C159.2 -0.0997415 160.6 1.00026 160.6 3.20026V139.6Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 235.7L0.5 232L160.6 139.6L167 143.3L7 235.7Z",
    fill: "#59CCBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.5 95.5998V232L7 235.7V99.2998C7 98.1998 7.3 96.8998 7.9 95.8998C5.5 95.1998 3.3 94.0998 1.1 92.7998C0.799998 93.6998 0.5 94.5998 0.5 95.5998Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M159.5 0.699855C158.9 0.399855 158.3 0.399855 157.5 0.899855L3.6001 89.6999C2.6001 90.2999 1.7001 91.4999 1.1001 92.7999C3.2001 94.0999 5.5001 95.1999 7.9001 95.8999C8.5001 94.7999 9.2001 93.8999 10.1001 93.4999L164 4.59986C164.8 4.19986 165.5 4.09985 166 4.49986L159.5 0.699855Z",
    fill: "#59CCBE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.00005 99.2998C7.00005 96.9998 8.40004 94.3998 10.1 93.3998L164 4.59982C164.6 4.29982 165.1 4.19982 165.6 4.29982C165 3.79982 164.2 3.69982 163.3 4.19982L9.40005 92.9998C7.70005 93.9998 6.30005 96.5998 6.30005 98.8998V235.3L7.00005 235.7V99.2998Z",
    fill: "#59CCBE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29996 94.0002L2.49995 90.7002C1.99995 91.3002 1.49995 92.0002 1.19995 92.8002C0.899951 93.4002 0.799951 94.0002 0.699951 94.6002L6.49995 97.9002C6.59995 96.5002 7.29996 95.0002 8.29996 94.0002Z",
    fill: "#59CCBE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09985 98.3002C7.19985 97.9002 7.29986 97.5002 7.39986 97.2002C7.19986 97.6002 7.09985 98.0002 7.09985 98.3002Z",
    fill: "url(#paint2_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8999 94.4004C8.4999 94.8004 8.1999 95.3004 7.8999 95.9004C8.1999 95.3004 8.4999 94.8004 8.8999 94.4004Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 97.0004C7.4999 96.6004 7.6999 96.2004 7.8999 95.9004C7.6999 96.2004 7.5999 96.6004 7.3999 97.0004Z",
    fill: "url(#paint4_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167 143.299L7 235.699V99.2995C7 96.9995 8.4 94.3995 10.1 93.3995L164 4.59948C165.7 3.59948 167.1 4.69948 167.1 6.89948V143.299H167Z",
    fill: "url(#paint5_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M163.6 145L10.4001 233.5C8.9001 234.4 7.1001 233.3 7.1001 231.6V98.9001C7.1001 96.6001 8.5001 94.0001 10.2001 93.0001L164 4.20006C165.7 3.20006 167.1 4.30006 167.1 6.50006V139C167 141.5 165.7 143.7 163.6 145Z",
    fill: "url(#paint6_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 234.7C8.6 234.7 8.1 234.6 7.6 234.3C6.6 233.7 6 232.7 6 231.5V98.9C6 96.3 7.6 93.3 9.6 92.2L163.5 3.40002C164.6 2.80002 165.6 2.70002 166.5 3.20002C167.5 3.80002 168.1 5.00002 168.1 6.50002V139C168.1 141.8 166.6 144.4 164.2 145.8L11 234.3C10.3 234.6 9.8 234.7 9.2 234.7ZM165.2 4.80002C164.9 4.80002 164.7 4.90002 164.5 5.00002L10.6 93.8C9.2 94.6 8 96.9 8 98.8V231.4C8 232 8.4 232.4 8.6 232.5C8.8 232.6 9.3 232.8 9.8 232.5L163 144C164.8 143 165.9 141 165.9 138.9V6.50002C165.9 5.50002 165.6 5.00002 165.3 4.90002C165.4 4.90002 165.3 4.80002 165.2 4.80002Z",
    fill: "url(#paint7_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.3 50.7002V119.5L151.2 128.6V59.9002L135.3 50.7002Z",
    fill: "url(#paint8_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.3 50.7002V119.5L119.5 128.6V59.9002L135.3 50.7002Z",
    fill: "url(#paint9_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.3 69.0002L119.5 59.9002L135.3 50.7002L151.2 59.9002L135.3 69.0002Z",
    fill: "url(#paint10_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.3 68.6006L119.9 59.6006L119.5 59.9006L135.3 69.0006L151.2 59.9006L150.8 59.6006L135.3 68.6006Z",
    fill: "url(#paint11_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M135.3 137.8L119.5 128.6L135.3 119.5L151.2 128.6L135.3 137.8Z",
    fill: "#88DBD1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.5 59.9004V128.6L135.3 137.8V69.0004L119.5 59.9004Z",
    fill: "url(#paint12_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M151.2 59.9004V128.6L135.3 137.8V69.0004L151.2 59.9004Z",
    fill: "url(#paint13_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.6 89.7002V137.7L119.5 146.8V98.8002L103.6 89.7002Z",
    fill: "url(#paint14_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.6 89.7002V137.7L87.8 146.8V98.8002L103.6 89.7002Z",
    fill: "url(#paint15_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.6 108L87.8 98.8002L103.6 89.7002L119.5 98.8002L103.6 108Z",
    fill: "url(#paint16_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.6 107.501L88.2 98.6006L87.8 98.8006L103.6 108.001L119.5 98.8006L119.1 98.6006L103.6 107.501Z",
    fill: "url(#paint17_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M103.6 156L87.8 146.8L103.6 137.7L119.5 146.8L103.6 156Z",
    fill: "#88DBD1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M87.8 98.7998V146.8L103.6 156V108L87.8 98.7998Z",
    fill: "url(#paint18_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.5 98.7998V146.8L103.6 156V108L119.5 98.7998Z",
    fill: "url(#paint19_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.9001 128.399V155.899L87.8002 164.999V137.499L71.9001 128.399Z",
    fill: "url(#paint20_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.9001 128.399V155.899L56.1001 164.999V137.499L71.9001 128.399Z",
    fill: "url(#paint21_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.9001 146.599L56.1001 137.499L71.9001 128.399L87.8001 137.499L71.9001 146.599Z",
    fill: "url(#paint22_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.9001 146.2L56.5001 137.3L56.1001 137.5L71.9001 146.6L87.8001 137.5L87.4001 137.3L71.9001 146.2Z",
    fill: "url(#paint23_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M71.9001 174.199L56.1001 164.999L71.9001 155.899L87.8001 164.999L71.9001 174.199Z",
    fill: "#88DBD1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.1001 137.499V164.999L71.9001 174.199V146.599L56.1001 137.499Z",
    fill: "url(#paint24_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M87.8002 137.499V164.999L71.9001 174.199V146.599L87.8002 137.499Z",
    fill: "url(#paint25_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.2 149.2V174.2L56.1 183.3V158.3L40.2 149.2Z",
    fill: "url(#paint26_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.1999 149.2V174.2L24.3999 183.3V158.3L40.1999 149.2Z",
    fill: "url(#paint27_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.1999 167.4L24.3999 158.3L40.1999 149.2L56.0999 158.3L40.1999 167.4Z",
    fill: "url(#paint28_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.1999 167.001L24.7999 158.101L24.3999 158.301L40.1999 167.401L56.0999 158.301L55.6999 158.101L40.1999 167.001Z",
    fill: "url(#paint29_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.1999 192.5L24.3999 183.3L40.1999 174.2L56.0999 183.3L40.1999 192.5Z",
    fill: "#88DBD1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.3999 158.3V183.3L40.1999 192.5V167.4L24.3999 158.3Z",
    fill: "url(#paint30_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.1 158.3V183.3L40.2 192.5V167.4L56.1 158.3Z",
    fill: "url(#paint31_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50.5452,
    y1: 95.9031,
    x2: 154.826,
    y2: 148.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4.2249,
    y1: 96.7656,
    x2: 4.2249,
    y2: 234.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.28556,
    y1: 96.8474,
    x2: 7.19196,
    y2: 98.1865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E394F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 8.5088,
    y1: 93.8819,
    x2: 8.3849,
    y2: 95.6541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E394F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 7.7366,
    y1: 95.5061,
    x2: 7.6454,
    y2: 96.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E384F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 27.6749,
    y1: 94.2367,
    x2: 162.319,
    y2: 152.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 87,
    y1: 23,
    x2: 106,
    y2: 357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#014F43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 11.2129,
    y1: 85.4485,
    x2: 162.999,
    y2: 152.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 115.47,
    y1: 57.6472,
    x2: 151.833,
    y2: 99.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 112.061,
    y1: 81.0322,
    x2: 162.879,
    y2: 109.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 125.691,
    y1: 56.4207,
    x2: 140.577,
    y2: 74.4257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 130.901,
    y1: 64.1198,
    x2: 166.812,
    y2: 64.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 108.85,
    y1: 91.2673,
    x2: 156.798,
    y2: 110.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 111.959,
    y1: 81.2172,
    x2: 162.776,
    y2: 109.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 90.0556,
    y1: 93.4762,
    x2: 118.192,
    y2: 125.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 83.9871,
    y1: 111.656,
    x2: 122.803,
    y2: 133.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 93.9909,
    y1: 95.3738,
    x2: 108.877,
    y2: 113.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 99.2007,
    y1: 103.073,
    x2: 135.112,
    y2: 103.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 80.4425,
    y1: 121.19,
    x2: 119.886,
    y2: 137.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 87.6498,
    y1: 113.957,
    x2: 126.465,
    y2: 135.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 64.5627,
    y1: 129.084,
    x2: 84.5751,
    y2: 152.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 55.868,
    y1: 142.124,
    x2: 82.8319,
    y2: 157.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 62.291,
    y1: 134.066,
    x2: 77.1767,
    y2: 152.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 67.5008,
    y1: 141.765,
    x2: 103.412,
    y2: 142.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 51.9941,
    y1: 150.965,
    x2: 83.0397,
    y2: 163.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 63.2484,
    y1: 146.514,
    x2: 90.2123,
    y2: 161.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 33.6332,
    y1: 149.504,
    x2: 52.6369,
    y2: 171.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 24.6122,
    y1: 161.906,
    x2: 50.1046,
    y2: 176.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 30.5907,
    y1: 154.869,
    x2: 45.4764,
    y2: 172.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 35.8005,
    y1: 162.568,
    x2: 71.7116,
    y2: 163.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 20.6975,
    y1: 170.661,
    x2: 50.7005,
    y2: 182.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 32.4542,
    y1: 166.555,
    x2: 57.9468,
    y2: 180.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013F37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.d0f88d26b1cedceaeabad90bf3a80be9.svg";
export { ForwardRef as ReactComponent };